import store from '@/store';
import eventReport, { EVENT_NAME } from '@/api/eventReport';

export function createRouterGuards(router) {
  let hasSavedLaunchQuery = false;

  router.beforeEach((to, from, next) => {
    if (!hasSavedLaunchQuery) {
      store.commit('SET_LAUNCH_QUERY', { ...to.query });
      hasSavedLaunchQuery = true;
    }

    eventReport.track(EVENT_NAME.ENTER_OFFICIAL_RECHARGE, {
      game_id: to.query.game_id || '',
      area: to.query.area || '',
      from: to.query.from || ''
    });
    next();
  });
}
